import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Account.Logout.IRequest;
type Response = Api.Core.Account.Logout.IResponse;
type Headers = Api.Core.Account.Logout.IHeaders;
const apiAccountLogoutPath = '/api/Account/Logout';
export default async function accountLogoutApi(request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: apiAccountLogoutPath,
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
